export const withIntlNumber = (value) => {
  return new Intl.NumberFormat('en-US').format(Number(value).toFixed(0))
}
